import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "27.571",
      height: "19",
      x: ".5",
      y: ".5",
      fill: "#fff",
      stroke: "#000",
      rx: "1.5"
    }, null, -1),
    _createElementVNode("g", { fill: "#005498" }, [
      _createElementVNode("path", { d: "M22.722 8.008h-6.675l-.678.766-2.21 2.473-.679.766H5.893l.656-.766.307-.372.656-.766H4.514c-.547 0-1.007.46-1.007 1.03v2.166c0 .569.46 1.028 1.007 1.028h11.62c.548 0 1.314-.35 1.686-.766l1.75-1.991z" }),
      _createElementVNode("path", {
        fill: "#ffd800",
        d: "M24.057 5.689c.547 0 1.007.46 1.007 1.028v2.167c0 .569-.46 1.028-1.007 1.028h-3.02l.679-.765.328-.373.678-.766h-6.675l-3.567 3.984H5.85l4.749-5.362.175-.197c.394-.416 1.138-.766 1.707-.766h.24z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "bancontact"}) } }